'use client'

import { SDK } from '@absmartly/javascript-sdk'

import { type ABSmartlyEventLogger, type ABSmartlySDKOptions, type ContextData } from '../types'
import { type DeviceType } from './deviceType'
import setupForcedVariants from './variants'

const defaultEventLogger: ABSmartlyEventLogger = (_, eventName, data) => {
  if (eventName == 'error') {
    console.error(data)
  }
}

export type HydrateContextParams = {
  sdkConfig: ABSmartlySDKOptions
  contextData?: ContextData
  anonymousId: string | null
  deviceType: DeviceType
  experimentPrefix?: string
}

export const hydrateClientContext = ({
  sdkConfig,
  contextData,
  anonymousId,
  deviceType,
  experimentPrefix = 'test_',
}: HydrateContextParams) => {
  if (!contextData || !anonymousId) {
    return null
  }

  try {
    const sdk = new SDK({
      ...sdkConfig,
      eventLogger: defaultEventLogger,
    })
    const clientContext = sdk.createContextWith(
      {
        units: {
          anonymous_id: anonymousId,
        },
      },
      contextData
    )

    clientContext.ready().catch(console.error)
    clientContext.attributes({
      url: window.location.href,
      page_url: window.location.href,
      page_path: window.location.pathname,
      user_agent: navigator.userAgent,
      environment: sdkConfig.environment,
      device_type: deviceType,
    })
    setupForcedVariants(clientContext, experimentPrefix)
    return clientContext
  } catch (error) {
    console.error('ABSmartly failed to hydrate on client:', error)
    return null
  }
}
